import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

let _toastIdCounter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = ++_toastIdCounter;
    setToasts(prev => [...prev, { id, message, type, duration, exiting: false }]);
  }, []);

  const removeToast = useCallback((id) => {
    // Mark as exiting first (for slide-out animation), then remove
    setToasts(prev => prev.map(t => t.id === id ? { ...t, exiting: true } : t));
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 350);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, toasts, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx.showToast;
}

// Exported for use by ToastContainer
export function useToastState() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToastState must be used inside ToastProvider');
  return { toasts: ctx.toasts, removeToast: ctx.removeToast };
}
